<cmps-wait-status *ngIf="state?.pending?.reload"></cmps-wait-status>

<ng-container
    [formGroup]="_evalFormGroup"
    *ngIf="_evalFormGroup != null && state?.form != null"
>
    <div
        class="cmps-cdk-d-flex cmps-cdk-flex-100 cmps-cdk-flex-wrap cmps-cdk-align-items-center cmps-cdk-justify-content-flex-end"
    >
        <button
            class="cmps-icon-button--no-bg"
            cmpsIconButton
            (click)="_onCloseEvalFormClick()"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
    <div class="cmps-cdk-d-flex cmps-cdk-flex-100 cmps-cdk-flex-wrap">
        <div class="cmps-cdk-flex-100 cmps-cdk-flex-xl-75 cmps-cdk-pr-xl-1dot5">
            <cmps-card-next class="cmps-cdk-mb-1dot5">
                <cmps-card-header-next>
                    {{ _i18n._9997_EVALUATION_DETAILS | translate }}
                </cmps-card-header-next>
                <cmps-card-body-next>
                    <div class="cmps-cdk-d-flex cmps-cdk-mx-n0dot5">
                        <div class="cmps-cdk-flex-15 cmps-cdk-p-0dot5">
                            {{ _i18n._1502_INDIVIDUAL | translate }}
                        </div>
                        <div class="cmps-cdk-flex-35 cmps-cdk-p-0dot5">
                            {{
                                _evalFormGroup?.value?.targetUserName ??
                                    state?.targetUser?.firstName +
                                        ' ' +
                                        state?.targetUser?.lastName
                            }}
                        </div>
                        <div class="cmps-cdk-flex-15 cmps-cdk-p-0dot5">
                            {{ _i18n._9998_EVALUATION_NAME | translate }}
                        </div>
                        <div class="cmps-cdk-flex-35 cmps-cdk-p-0dot5">
                            {{ _evalFormGroup?.value?.name }}
                        </div>
                    </div>
                    <div class="cmps-cdk-d-flex cmps-cdk-mx-n0dot5">
                        <ng-container
                            *ngIf="
                                state.displayControls?.displayManager &&
                                state?.response?.responseId != null
                            "
                        >
                            <div class="cmps-cdk-flex-15 cmps-cdk-p-0dot5">
                                {{ _i18n._48_MANAGER | translate }}
                            </div>
                            <div class="cmps-cdk-flex-35 cmps-cdk-p-0dot5">
                                {{ state?.form?.targetManagerUserName }}
                            </div>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                state.displayControls?.displayEvaluator &&
                                state?.response?.responseId != null
                            "
                        >
                            <div class="cmps-cdk-flex-15 cmps-cdk-p-0dot5">
                                {{ _i18n._10030_EVALUATOR | translate }}
                            </div>
                            <div class="cmps-cdk-flex-35 cmps-cdk-p-0dot5">
                                {{ state?.form?.evaluatorUserName }}
                            </div>
                        </ng-container>
                    </div>
                    <div class="cmps-cdk-d-flex cmps-cdk-mx-n0dot5">
                        <div class="cmps-cdk-flex-15 cmps-cdk-p-0dot5">
                            {{ _i18n._9999_EVENT_DATE | translate }}
                        </div>
                        <div
                            class="cmps-form-input-group cmps-cdk-flex-35 cmps-cdk-p-0dot5"
                        >
                            <input
                                class="cmps-form-input"
                                cmpsDateTimePicker
                                [onlyDate]="true"
                                formControlName="eventDate"
                                #dpEtd="cmpsDateTimePicker"
                            />
                            <button
                                class="cmps-icon-button--no-bg cmps-form-input-group--icon"
                                cmpsIconButton
                                [attr.aria-expanded]="dpEtd.isOpen()"
                                [disabled]="_evalFormGroup?.disabled"
                                (click)="dpEtd.toggle()"
                            >
                                <cmps-icon svgIcon="calendar-range"></cmps-icon>
                            </button>
                        </div>
                        <div class="cmps-cdk-flex-15 cmps-cdk-p-0dot5">
                            {{ _i18n._10000_EVENT_TIME | translate }}
                        </div>
                        <div
                            class="cmps-form-input-group cmps-cdk-flex-35 cmps-cdk-p-0dot5"
                        >
                            <input
                                class="cmps-form-input"
                                cmpsDateTimePicker
                                [onlyTime]="true"
                                formControlName="eventTime"
                                #dpEtt="cmpsDateTimePicker"
                            />
                            <button
                                class="cmps-icon-button--no-bg cmps-form-input-group--icon"
                                cmpsIconButton
                                [attr.aria-expanded]="dpEtt.isOpen()"
                                [disabled]="_evalFormGroup?.disabled"
                                (click)="dpEtt.toggle()"
                            >
                                <cmps-icon svgIcon="clock-outline"></cmps-icon>
                            </button>
                        </div>
                    </div>
                    <div
                        class="cmps-cdk-d-flex cmps-cdk-mx-n0dot5"
                        *ngIf="
                            state?.response?.responseId == null ||
                            (state.displayControls?.displayContactLength &&
                                state.displayControls?.displayQueue)
                        "
                    >
                        <ng-container
                            *ngIf="state.displayControls?.displayContactLength"
                        >
                            <ng-container
                                *ngTemplateOutlet="contactLengthTemplate"
                            ></ng-container>
                        </ng-container>
                        <ng-container
                            *ngIf="state.displayControls?.displayQueue"
                        >
                            <ng-container
                                *ngTemplateOutlet="queueTemplate"
                            ></ng-container>
                        </ng-container>
                    </div>
                    <div
                        class="cmps-cdk-d-flex cmps-cdk-mx-n0dot5"
                        *ngIf="state?.response?.responseId != null"
                    >
                        <div class="cmps-cdk-flex-15 cmps-cdk-p-0dot5">
                            {{ _i18n._10001_EVALUATION_DATE | translate }}
                        </div>
                        <div
                            class="cmps-form-input-group cmps-cdk-flex-35 cmps-cdk-p-0dot5"
                        >
                            <input
                                class="cmps-form-input"
                                cmpsDateTimePicker
                                [onlyDate]="true"
                                formControlName="evaluationDate"
                            />
                        </div>
                        <ng-container
                            *ngIf="
                                state?.response?.responseId != null &&
                                (!state.displayControls?.displayContactLength ||
                                    !state.displayControls?.displayQueue)
                            "
                        >
                            <ng-container
                                *ngIf="
                                    state.displayControls?.displayContactLength
                                "
                            >
                                <ng-container
                                    *ngTemplateOutlet="contactLengthTemplate"
                                ></ng-container>
                            </ng-container>
                            <ng-container
                                *ngIf="state.displayControls?.displayQueue"
                            >
                                <ng-container
                                    *ngTemplateOutlet="queueTemplate"
                                ></ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </cmps-card-body-next>
            </cmps-card-next>

            <!--            <cmps-breakpoint mediaQuery="(min-width: 1200px)">-->
            <!--                <ng-container *ngTemplateOutlet="groupsTpl"></ng-container>-->
            <!--            </cmps-breakpoint>-->

            <div class="cmps-cdk-d-none cmps-cdk-d-xl-block">
                <ng-container *ngTemplateOutlet="groupsTpl"></ng-container>
            </div>
        </div>

        <div class="cmps-cdk-flex-100 cmps-cdk-flex-xl-25 cmps-cdk-mb-1dot5">
            <cmps-card-next class="cmps-eval-form--total-header">
                <cmps-card-header-next>
                    {{ _i18n._10002_TOTAL_SCORE | translate }}
                </cmps-card-header-next>
                <cmps-card-body-next>
                    <div>{{ _i18n._10019_SUMMARY_COMMENTS | translate }}</div>
                    <ng-container formArrayName="comments">
                        <cmps-comment formControlName="0"></cmps-comment>
                    </ng-container>
                    <div class="cmps-eval-form--total-score">
                        <cmps-eval-score-label
                            [hideLabel]="true"
                            [numerator]="_evalFormGroup?.value?.score"
                            [denominator]="_evalFormGroup?.value?.diffMaxScore"
                            [percentage]="_evalFormGroup?.value?.percentage"
                        ></cmps-eval-score-label>
                        <cmps-eval-score-alert
                            [label]="
                                _i18n._10006_THE_SCORE_HAS_BEEN_AFFECTED_BY_AN_AUTO_FAIL_EVENT
                                    | translate
                            "
                            *ngIf="_evalFormGroup?.errors?.eval"
                        >
                        </cmps-eval-score-alert>
                    </div>
                    <cmps-progress-bar
                        color="#1e60d4"
                        [value]="_evalFormGroup?.value?.percentage"
                    ></cmps-progress-bar>
                    <div
                        class="cmps-eval-form--total-btns cmps-cdk-mt-1"
                        *ngIf="state?.draft != null && _viewOnly !== true"
                    >
                        <button
                            class="cmps-outline-button--outline cmps-cdk-flex-40 cmps-cdk-mr-1 cmps-cdk-min-w-xl-auto cmps-cdk-min-w-xxl-inherit"
                            cmpsOutlineButton
                            [disabled]="state?.pending?.save"
                            (click)="_onSaveClick()"
                        >
                            <span cmpsOutlineButtonLabel>{{
                                _i18n._10005_SAVE_AS_DRAFT | translate
                            }}</span>
                        </button>
                        <!-- TODO revise. how to inform users of required fields -->
                        <button
                            class="cmps-button--publish cmps-cdk-flex-60"
                            cmpsButton
                            [disabled]="
                                state?.pending?.save ||
                                this._evalFormGroup.errors?.questionReasons !=
                                    null
                            "
                            (click)="_onPublishClick()"
                        >
                            <span cmpsOutlineButtonLabel>{{
                                _i18n._9415_PUBLISH | translate
                            }}</span>
                        </button>
                    </div>
                    <div
                        class="cmps-eval-form--total-btns cmps-cdk-mt-1"
                        *ngIf="
                            state?.response?.responseId != null &&
                            state.canEditResponse &&
                            _viewOnly !== true
                        "
                    >
                        <button
                            class="cmps-outline-button--outline cmps-cdk-flex-100"
                            cmpsOutlineButton
                            [disabled]="state?.pending?.save"
                            (click)="_onUpdatePublishClick()"
                        >
                            <span cmpsOutlineButtonLabel>{{
                                _i18n._10020_SAVE | translate
                            }}</span>
                        </button>
                    </div>
                </cmps-card-body-next>
            </cmps-card-next>
            <cmps-card-next class="cmps-eval-form--expand-btns">
                <cmps-card-body-next class="cmps-cdk-flex-100">
                    <div class="cmps-eval-form--total-btns">
                        <button
                            class="cmps-outline-button--outline cmps-cdk-flex-45 cmps-cdk-min-w-xl-auto cmps-cdk-min-w-xxl-inherit"
                            cmpsOutlineButton
                            [disabled]="state?.pending?.save"
                            (click)="_onExpandFormClick(false)"
                        >
                            <span cmpsOutlineButtonLabel>{{
                                _i18n._11076_EXPAND_ALL_GROUPS | translate
                            }}</span>
                        </button>
                        <button
                            class="cmps-outline-button--outline cmps-cdk-flex-45 cmps-cdk-min-w-xl-auto cmps-cdk-min-w-xxl-inherit"
                            cmpsOutlineButton
                            [disabled]="state?.pending?.save"
                            (click)="_onExpandFormClick(true)"
                        >
                            <span cmpsOutlineButtonLabel>{{
                                _i18n._11077_COLLAPSE_ALL_GROUPS | translate
                            }}</span>
                        </button>
                    </div>
                </cmps-card-body-next>
            </cmps-card-next>
        </div>
    </div>

    <!--    <cmps-breakpoint class="cmps-cdk-d-flex cmps-cdk-flex-100 cmps-cdk-d-xl-none" mediaQuery="(max-width: 1199.98px)">-->
    <!-- Contact Length and Queue Templates for Reusability -->
    <ng-template #contactLengthTemplate>
        <div class="cmps-cdk-flex-15 cmps-cdk-p-0dot5">
            {{ _i18n._11078_CONTACT_LENGTH | translate }}
        </div>
        <div class="cmps-form-input-group cmps-cdk-flex-35 cmps-cdk-p-0dot5">
            <input
                class="cmps-form-input"
                formControlName="contactLength"
                type="text"
                [aria-label]="_i18n._11078_CONTACT_LENGTH | translate"
            />
            <span
                class="cmps-minutes-text cmps-cdk-d-flex cmps-cdk-align-items-center .cmps-cdk-pr-1"
                >{{ _i18n._11079_MINUTES | translate }}</span
            >
        </div>
    </ng-template>

    <ng-template #queueTemplate>
        <div class="cmps-cdk-flex-15 cmps-cdk-p-0dot5">
            {{ _i18n._9715_QUEUE_ | translate }}
        </div>
        <div class="cmps-cdk-flex-35 cmps-cdk-p-0dot5">
            <ng-select
                #dropDownQueue
                class="ng-select--variant-2"
                [options]="_queueOpts"
                formControlName="queue"
                (opened)="_onDropdownOpen()"
            ></ng-select>
        </div>
    </ng-template>
    <!--    <cmps-breakpoint class="cmps-cdk-d-flex cmps-flex-100 cmps-d-xl-none" mediaQuery="(max-width: 1199.98px)">-->
    <!--        <ng-container *ngTemplateOutlet="groupsTpl"></ng-container>-->
    <!--    </cmps-breakpoint>-->

    <div class="cmps-cdk-d-flex cmps-cdk-flex-100 cmps-cdk-d-xl-none">
        <ng-container *ngTemplateOutlet="groupsTpl"></ng-container>
    </div>

    <ng-template #groupsTpl>
        <div
            class="cmps-eval-form--groups cmps-cdk-d-flex cmps-cdk-flex-100 cmps-cdk-flex-column"
            formArrayName="groups"
        >
            <cmps-card-next
                [collapsable]="true"
                (collapsedChange)="_onGroupToggleClick(gi)"
                [collapsed]="g?.value?.collapsed"
                [formGroupName]="gi"
                *ngFor="let g of _groups()?.controls; index as gi"
            >
                <cmps-card-header-next class="cmps-eval-form--group-header">
                    <div class="cmps-eval-form--group-header-label">
                        {{ g?.value?.name }}
                    </div>
                    <div
                        class="cmps-eval-form--group-header-score cmps-cdk-flex-30"
                    >
                        <cmps-eval-score-label
                            [numerator]="g?.value?.score"
                            [denominator]="g?.value?.diffMaxScore"
                            [percentage]="g?.value?.percentage"
                        ></cmps-eval-score-label>
                        <cmps-eval-score-alert
                            [label]="
                                _i18n._10006_THE_SCORE_HAS_BEEN_AFFECTED_BY_AN_AUTO_FAIL_EVENT
                                    | translate
                            "
                            *ngIf="
                                _evalFormGroup?.errors?.groups?.[
                                    g?.value?.groupId
                                ] ?? g?.value?.hasChildError
                            "
                        >
                        </cmps-eval-score-alert>
                    </div>
                </cmps-card-header-next>
                <cmps-card-body-next
                    class="cmps-eval-form--group-body"
                    formArrayName="sections"
                >
                    <cmps-card-next
                        [collapsable]="true"
                        [formGroupName]="si"
                        *ngFor="let s of _sections(g)?.controls; index as si"
                    >
                        <cmps-card-header-next
                            class="cmps-eval-form--section-header"
                        >
                            <div class="cmps-eval-form--section-header-label">
                                {{ s?.value?.name }}
                            </div>
                            <div
                                class="cmps-eval-form--section-header-score cmps-cdk-flex-30"
                            >
                                <cmps-eval-score-label
                                    [numerator]="s?.value?.score"
                                    [denominator]="s?.value?.diffMaxScore"
                                    [percentage]="s?.value?.percentage"
                                ></cmps-eval-score-label>
                                <cmps-eval-score-alert
                                    [label]="
                                        _i18n._10006_THE_SCORE_HAS_BEEN_AFFECTED_BY_AN_AUTO_FAIL_EVENT
                                            | translate
                                    "
                                    *ngIf="
                                        _evalFormGroup?.errors?.sections?.[
                                            s?.value?.sectionId
                                        ] ?? s?.value?.hasChildError
                                    "
                                >
                                </cmps-eval-score-alert>
                            </div>
                        </cmps-card-header-next>
                        <cmps-card-body-next formArrayName="questions">
                            <ng-container
                                [formGroupName]="qi"
                                *ngFor="
                                    let q of _questions(s)?.controls;
                                    index as qi
                                "
                            >
                                <ng-container
                                    [ngSwitch]="q?.value?.type"
                                    *ngIf="
                                        q?.value?.visibility?.notVisible !==
                                        true
                                    "
                                >
                                    <div
                                        class="cmps-eval-form--radio-question"
                                        [class.cmps-eval-form--radio-question-score-alert]="
                                            _evalFormGroup?.errors?.questions?.[
                                                q?.value?.questionId
                                            ]
                                        "
                                        *ngSwitchCase="
                                            _QuestionType.RadioButton
                                        "
                                    >
                                        <div
                                            class="cmps-cdk-d-flex cmps-cdk-flex-100"
                                        >
                                            <div
                                                class="cmps-eval-form--radio-question-question cmps-cdk-flex-70"
                                            >
                                                {{ q?.value?.text }}
                                            </div>
                                            <div
                                                class="cmps-eval-form--radio-question-options cmps-cdk-flex-20"
                                            >
                                                <cmps-radio-group
                                                    formControlName="optionId"
                                                    *ngIf="
                                                        q?.value?.visibility
                                                            ?.responseNotVisible !==
                                                        true
                                                    "
                                                >
                                                    <ng-container
                                                        *ngFor="
                                                            let o of q?.value
                                                                ?.options
                                                        "
                                                    >
                                                        <!--TODO fix cmps-radio-group -> cmps-radio control value accessor form disable-->
                                                        <cmps-radio
                                                            [value]="
                                                                o?.optionId
                                                            "
                                                            [disabled]="
                                                                _evalFormGroup?.disabled
                                                            "
                                                            >{{
                                                                o?.text
                                                            }}</cmps-radio
                                                        >
                                                    </ng-container>
                                                </cmps-radio-group>
                                            </div>
                                            <div
                                                class="cmps-eval-form--radio-question-score cmps-cdk-flex-10"
                                            >
                                                {{
                                                    (q?.value?.optionId != null
                                                        ? q?.value?.score
                                                        : 0
                                                    ) | cmpsNumber: '1.2-2'
                                                }}
                                            </div>
                                        </div>
                                        <div
                                            class="cmps-cdk-d-flex cmps-cdk-flex-100 cmps-cdk-justify-content-flex-end"
                                            *ngIf="
                                                q?.value?.visibility
                                                    ?.responseReasonNotVisible !==
                                                true
                                            "
                                        >
                                            <div
                                                class="cmps-eval-form--radio-question-reason cmps-cdk-flex-30"
                                            >
                                                <cmps-eval-reason
                                                    [options]="
                                                        q?.value?.options
                                                    "
                                                    [optionId]="
                                                        q?.value?.optionId
                                                    "
                                                    formControlName="optionReasonValue"
                                                ></cmps-eval-reason>
                                            </div>
                                        </div>
                                        <cmps-eval-score-alert
                                            [label]="
                                                _i18n._10007_THIS_QUESTION_HAS_TRIGGERED_AN_AUTO_FAIL_EVENT
                                                    | translate
                                            "
                                            *ngIf="
                                                _evalFormGroup?.errors
                                                    ?.questions?.[
                                                    q?.value?.questionId
                                                ] ?? q?.value?.hasChildError
                                            "
                                        >
                                        </cmps-eval-score-alert>
                                    </div>
                                    <div *ngSwitchCase="_QuestionType.CheckBox">
                                        <div>{{ q?.value?.text }}</div>
                                        <div>
                                            <cmps-checkbox
                                                formControlName="boolValue"
                                                *ngIf="
                                                    q?.value?.visibility
                                                        ?.responseNotVisible !==
                                                    true
                                                "
                                            ></cmps-checkbox>
                                        </div>
                                    </div>
                                    <div
                                        class="cmps-eval-form--text-question"
                                        *ngSwitchCase="_QuestionType.TextBox"
                                    >
                                        <div
                                            class="cmps-eval-form--text-question-question"
                                        >
                                            {{ q?.value?.text }}
                                        </div>
                                        <div
                                            class="cmps-eval-form--text-question-box"
                                        >
                                            <cmps-comment
                                                formControlName="textValue"
                                                *ngIf="
                                                    q?.value?.visibility
                                                        ?.responseNotVisible !==
                                                    true
                                                "
                                            ></cmps-comment>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </cmps-card-body-next>
                    </cmps-card-next>
                </cmps-card-body-next>
            </cmps-card-next>
        </div>
    </ng-template>
</ng-container>
